import React from "react";
import { HOST_URL, MediaBaseUrl } from "../../../../../actions/api";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "../../../../CommonComponents/AssetsHelper";

const SetupUse = () => {
    return (
        <div className="p-md-10 p-5 bg-gray rounded">
            <div className="">
                <div className="text-center p-8 bg-light-gray">
                   <img src={`${MediaBaseUrl}images/hard-to-use.png`} className="img-fluid pb-2" width="165px" height="200px" />
                    <p>We understand that ease of use is crucial. Would you like to book a free call with our experts who will guide you through the setup and handle all your queries?</p>
                    <div className="d-flex justify-content-center">
                        <Button variant="primary" onClick={() => window.open(`https://calendly.com/taggbox/demo?utm_source=Widget&utm_medium=${HOST_URL}/widget/&utm_campaign=calendly_Request_demo_click`, '_blank')}>
                            <FontAwesomeIcon type={'regular'} icon={'headset'} iconClass={'text-white me-2'} /> Book Call
                        </Button>
                        <Button variant="dark" className="ms-2" onClick={() => window.Intercom ? window.Intercom('show') : null}>
                            <FontAwesomeIcon type={'regular'} icon={'comment'} iconClass={'text-white me-2'} /> Talk To Us
                            </Button>
                    </div>
                </div>
                <div className="alert alert-custom fade show mt-3 p-0 mb-0 rounded-0 align-items-start rounded-2">
                    <div className="alert-icon py-1 f-center">
                        <FontAwesomeIcon type={'solid'} icon={'info'} iconClass={'fs-6 me-2'} />
                        <p className="flex-grow-1">Apologies for any inconvenience! We want to ensure a smooth experience. Could you share more details about the technical issues you've encountered? Our team is here to assist.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SetupUse
